export const AiResultDEEmailMappings = {
  "Hair Gloss": {
    key: "hairGloss",
    value: { Glossy: "Glänzend", Dry: "Stumpf" },
  },
  "Hair Volume": {
    key: "hairVolume",
    value: {
      unknown: "Unbekannt",
      high: "Viel",
      medium: "Mittel",
      low: "Wenig",
    },
  },
  "Hair Length": {
    key: "hairLength",
    value: {
      unknown: "Unbekannt",
      "very-short (male)": "Sehr kurz",
      "short (male)": "Kurz",
      "medium (male)": "Mittel",
      "long (male)": "Lang",
      "very-short (female)": "Sehr kurz",
      "short (female)": "Kurz",
      "medium (female)": "Mittel",
      "chin-length (female)": "Kinnlang",
      "neck-length (female)": "Neckline",
      "shoulder-length (female)": "Schulterlang",
      "long (female)": "Lang",
    },
  },
  "Hair Color": {
    key: "hairColor",
    value: {
      unknown: "Unbekannt",
      black: "Schwarz",
      "black-brown": "Schwarzbraun",
      "dark-brown": "Dunkelbraun",
      "medium-brown": "Mittelbraun",
      "bright-brown": "Hellbraun",
      "dark-blonde": "Dunkelblond",
      "medium-blonde": "Mittelblond",
      "bright-blonde": "Hellblond",
      "platinum-blonde": "Platinblond",
      grey: "Grau",
      white: "Weiß",
      "salt-and-pepper": "Salz und Pfeffer",
      auburn: "Rotbraun",
      burgundy: "Burgunderrot",
      ginger: "Fuchsrot",
      "copper-brown": "Kupferbraun",
    },
  },
  "Hair Texture v2": {
    key: "hairTexture",
    value: {
      unknown: "Unbekannt",
      straight: "Glatt",
      wavy: "Gewellt",
      curly: "Lockig",
      kinky: "Gekräuselt",
      coily: "Gekräuselt",
    },
  },
};

export const AiResultENEmailMappings = {
  "Hair Gloss": {
    key: "hairGloss",
    value: { Glossy: "Glossy", Dry: "Dull" },
  },
  "Hair Volume": {
    key: "hairVolume",
    value: {
      unknown: "Unknown",
      high: "High",
      medium: "Medium",
      low: "Low",
    },
  },
  "Hair Length": {
    key: "hairLength",
    value: {
      unknown: "Unknown",
      "very-short (male)": "Very short",
      "short (male)": "Short",
      "medium (male)": "Medium",
      "long (male)": "Long",
      "very-short (female)": "Very short",
      "short (female)": "Short",
      "medium (female)": "Medium",
      "chin-length (female)": "Chin-length",
      "neck-length (female)": "Neck-length",
      "shoulder-length (female)": "Shoulder-length",
      "long (female)": "Long",
    },
  },
  "Hair Color": {
    key: "hairColor",
    value: {
      unknown: "Unknown",
      black: "Black",
      "black-brown": "Black-brown",
      "dark-brown": "Dark brown",
      "medium-brown": "Medium brown",
      "bright-brown": "Light brown",
      "dark-blonde": "Dark blonde",
      "medium-blonde": "Medium blonde",
      "bright-blonde": "Light blonde",
      "platinum-blonde": "Platinum blonde",
      grey: "Grey",
      white: "White",
      "salt-and-pepper": "Salt and pepper",
      auburn: "Auburn",
      burgundy: "Burgundy",
      ginger: "Ginger",
      "copper-brown": "Copper brown",
    },
  },
  "Hair Texture v2": {
    key: "hairTexture",
    value: {
      unknown: "Unknown",
      straight: "Straight",
      wavy: "Wavy",
      curly: "Curly",
      kinky: "Kinky",
      coily: "Coily",
    },
  },
};
